import { useFetchOglink } from '@lopo-tech/lopo-api'
import { useCallback } from 'react'
import { REGEXP_URL } from 'src/utils/pattern/pattern'

export const useDetectLink = () => {
  const [fetchOglink] = useFetchOglink()

  const detectLink = useCallback(async (text: string) => {
    const urlsFoundInText = text.match(REGEXP_URL)

    if (urlsFoundInText?.[0]) {
      return await fetchOglink({
        variables: { input: { url: urlsFoundInText[0] } }
      })
    }

    return undefined
  }, [fetchOglink])

  return detectLink
}
